/**
 * CyberSells Core - Main initialization & auto-start
 * This file loads after all modules and starts the gamification system
 */

(function() {
  'use strict';

  // Wait for all modules to load
  function waitForModules(callback, maxAttempts = 50) {
    let attempts = 0;
    
    const check = setInterval(() => {
      attempts++;
      
      // Check if core modules are loaded
      const modulesReady = 
        window.CyberSells_playerData &&
        window.CyberSells_stats &&
        window.CyberSells_toast;
      
      // Optional modules (check but don't require)
      const optionalModules = {
        achievements: !!window.CyberSells_achievements,
        quests: !!window.CyberSells_quests,
        cartProjection: !!window.CyberSells_cartProjection,
        postPurchase: !!window.CyberSells_postPurchase
      };
      
      if (modulesReady) {
        clearInterval(check);
        if (window.cyberSellsConfig?.debug) {
          console.log('[CyberSells] Optional modules loaded:', optionalModules);
        }
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(check);
        console.warn('[CyberSells] Modules failed to load within timeout');
      }
    }, 100);
  }

  // Initialize Equipment Console if present
  function initEquipmentConsole() {
    if (window.CyberSells_equipment) {
      // Always initialize equipment system (event listeners work even without console)
      window.CyberSells_equipment.setupEquipmentConsole({
        storageKey: 'cybersells_loadout',
        autoSave: true
      });
      console.log('[CyberSells] Equipment system initialized');
      
      // Initial load and update
      if (window.CyberSells_equipment.getLoadout) {
        const loadout = window.CyberSells_equipment.getLoadout();
        // Trigger initial equipment update event
        document.dispatchEvent(new CustomEvent('cybersells:equipment-changed', {
          detail: { action: 'init', loadout }
        }));
      }
    } else {
      console.warn('[CyberSells] Equipment module not loaded');
    }
  }

  // Initialize CyberSells when DOM and modules are ready
  function initCyberSells() {
    console.log('[CyberSells] Starting initialization...');
    
    // Create CyberSells instance using the class from cybersells/core.js
    if (!window.CyberSells) {
      console.error('[CyberSells] CyberSells class not found');
      return;
    }
    
    const config = window.cyberSellsConfig || {};
    const cs = new window.CyberSells(config);
    
    // Initialize
    cs.init();
    
    // Make instance globally available
    window.cyberSells = cs;
    
    // Initialize Equipment Console (optional module)
    initEquipmentConsole();
    
    // Auto-track product views on product pages
    if (document.body.classList.contains('template-product')) {
      const productId = document.querySelector('[data-product-id]')?.dataset.productId;
      const productTitle = document.querySelector('[data-product-title]')?.textContent;
      
      if (productId && window.CyberSells_purchaseHandler) {
        window.CyberSells_purchaseHandler.trackProductView(productId, productTitle);
      }
    }
    
    // Listen for Shopify cart events
    document.addEventListener('cart:updated', (event) => {
      console.log('[CyberSells] Cart updated', event.detail);
    });
    
    // Listen for add-to-cart
    document.addEventListener('cart:add', () => {
      if (window.CyberSells_purchaseHandler) {
        window.CyberSells_purchaseHandler.trackCartAdd();
      }
    });
    
    console.log('[CyberSells] Fully initialized and ready! ??');
  }

  // Start when DOM is ready (use { once: true } to prevent double initialization)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      waitForModules(initCyberSells);
    }, { once: true });
  } else {
    waitForModules(initCyberSells);
  }

})();
